import React from 'react';
import InsightMaster from './InsightMaster';

function Feeders() {
  return (
    <InsightMaster
      title="Feeders"
      modalTitle="Add Feeder"
      addButtonText="Add Feeder"
      searchPlaceholder="Search feeders..."
      nameLabel="Name *"
      namePlaceholder="Feeder name"
      itemType="FEEDER"
    />
  );
}

export default Feeders;
